"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonBack = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["children", "className", "disabled", "visible", "tag"];
var ButtonBack = exports.ButtonBack = function ButtonBack(props) {
  var children = props.children,
    className = props.className,
    disabled = props.disabled,
    visible = props.visible,
    tag = props.tag,
    buttonProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var buttonClasses = (0, _classnames["default"])('button-back', {
    'button-back_invisible': !visible,
    'button-back_disabled': disabled
  }, className);
  var BtnComponent = tag !== null && tag !== void 0 ? tag : 'button';
  return /*#__PURE__*/_react["default"].createElement(BtnComponent, (0, _extends2["default"])({}, buttonProps, {
    className: buttonClasses,
    disabled: disabled
  }), children);
};
ButtonBack.defaultProps = {
  disabled: false,
  visible: true
};